import { allowedModules, APP_MODULES } from 'constants/appModules';
import { generatePath } from 'react-router-dom';
import { UserDTO } from 'types/user';
import { WellFullDetailsDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

import { SidebarRoute } from './RouteLinks';

export const isModuleVisibleToUser = (user: UserDTO | null, modulesLinks: SidebarRoute[]) => {
  return user ? modulesLinks.some(module => isSubModuleVisibleToUser(user, module.module)) : false;
};

export const isSubModuleVisibleToUser = (user: UserDTO | null, ModuleName: APP_MODULES) => {
  return user?.profile ? allowedModules[user.profile].some(name => ModuleName === name) : false;
};

export const generatePathToRedirect = (
  viewPath: string,
  paramName?: string,
  queryParam?: string,
  well?: WellFullDetailsDTO,
  wellbore?: InnerWellboreWithWellInfo,
) => {
  const params: Record<string, string | undefined> = {
    tuwi: well?.tuwi,
    wellboreId: wellbore?.wellboreId,
    tuwbi: wellbore?.tuwbi,
  };

  if (queryParam) {
    return paramName && !params[paramName]
      ? viewPath
      : generatePath(`${viewPath}?${queryParam}=${paramName ? params[paramName] : ''}`);
  } else {
    return paramName && !params[paramName]
      ? ''
      : generatePath(viewPath, paramName ? { [paramName]: params[paramName] } : {});
  }
};
